"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import EmptyPlaceholder from "@/components/empty-placeholder";
import { useModal } from "@/components/modal-context";
import { useEffect, useState, useTransition } from "react";
import { GetAngpao, GetOTB, GetUserDetailAction, GetVipBonusInfo } from "@/lib/actions";
import { Button } from "@/components/custom";
import { useRouter } from "@/i18n/routing";
import { useLivechat } from "@/components/livechat-context";
import { Tooltip } from "@heroui/react";
import VipBonusModal from "./modals/vip-bonus";
import OTBModal from "./modals/otb";
import AngpaoModal from "./modals/angpao";

export default function Reward(/*{ angpaoList, otb }: { angpaoList: AngpaoObject[]; otb: any }*/) {
  const { openModal, closeModal } = useModal();
  const t = useTranslations();
  const router = useRouter();
  const [pending, startPending] = useTransition();
  const [rewards, setRewards] = useState<Record<string, any>[]>([]);
  const { openLivechat } = useLivechat();
  useEffect(() => {
    setRewards([]);
    startPending(() => {
      // GetUserDetailAction().then((res) => {
      //   console.log(res);
      // });
      GetAngpao().then((angpows) => {
        if (angpows.event_list.length === 0) {
          setRewards((prev) => [
            ...prev,
            {
              type: "angpao",
            },
          ]);
        }
        setRewards((prev) => [
          ...prev,
          ...angpows.event_list.map((e) => {
            return {
              type: "angpao",
              data: e,
            };
          }),
        ]);
      });

      GetOTB().then((otb) => {
        if (otb.data !== null) setRewards((prev) => [...prev, { type: "otb", data: otb.data.current_balance }]);
      });

      GetVipBonusInfo().then((res) => {
        if (res.data.claimable_amount > 0) setRewards((prev) => [...prev, { type: "vip-bonus", data: res.data }]);
      });

      setRewards((prev) => [
        ...prev,
        { type: "lp-store" },
        { type: "birthday" },
        { type: "free-spin" },
        { type: "wof" },
      ]);
    });
  }, []);

  const AngpaoClaimHandler = (event_id: string) => {
    openModal(<AngpaoModal event_id={event_id} />, "Angpao").then(() => {
      router.refresh();
    });
  };

  const OTBClaimHandler = () => {
    openModal(<OTBModal />, "OTB").then(() => {
      router.refresh();
    });
  };

  const VipBonusClaimHandler = () => {
    openModal(<VipBonusModal />, t("vip-bonus-title")).then(() => {
      router.refresh();
    });
  };

  const LPStoreClaimHandler = () => {
    // openModal("Feature is not available at the moment", "Coming Soon");
    router.push("/lp-store");
  };

  const BirthdayClaimHandler = () => {
    openModal(
      <section>
        <div className="flex flex-col gap-y-5 pb-5">
          To claim Birthday Bonus, please talk to our customer service.
          <Button
            onPress={() => {
              openLivechat();
              closeModal();
            }}
          >
            Open Livechat
          </Button>
        </div>
      </section>,
      "Birthday Bonus"
    );
  };

  return (
    <div className="relative grid grid-cols-3 flex-wrap items-center justify-center gap-4 px-4">
      <>
        {pending ? (
          <div className="absolute inset-0 flex size-full min-h-[calc(100svh-240px)] items-center justify-center">
            <span>Loading...</span>
          </div>
        ) : (
          <>
            {rewards.length === 0 ? (
              <div className="flex size-full min-h-[calc(100svh-240px)] items-center justify-center">
                <EmptyPlaceholder description={t("no-rewards")} />
              </div>
            ) : (
              <>
                {rewards.map((reward, index) => {
                  const topImgUrl = () => {
                    switch (reward.type) {
                      case "angpao":
                        return "/rewards/angpau.png?abc";
                      case "otb":
                      case "vip-bonus":
                        return "/rewards/free_credit.png?abc";
                      case "lp-store":
                        return "/rewards/lp_store.png?abc";
                      case "birthday":
                        return "/rewards/birthday.png?abc";
                      case "free-spin":
                        return "/rewards/free_spin.png";
                      case "wof":
                        return "/rewards/wheel_of_fortune.png";
                    }
                  };

                  const ClaimHandler = () => {
                    switch (reward.type) {
                      case "angpao":
                        AngpaoClaimHandler(reward.data.event_id);
                        break;
                      case "otb":
                        OTBClaimHandler();
                        break;
                      case "vip-bonus":
                        VipBonusClaimHandler();
                        break;
                      case "lp-store":
                        LPStoreClaimHandler();
                        break;
                      case "birthday":
                        BirthdayClaimHandler();
                        break;
                    }
                  };

                  const title = () => {
                    switch (reward.type) {
                      case "angpao":
                        return reward.data ? (reward.data.title as string) : t("no-salami");
                      case "otb":
                        return t("otb");
                      case "vip-bonus":
                        return t("vip-bonus-title");
                      case "lp-store":
                        return t("lp-store");
                      case "birthday":
                        return t("birthday-bonus");
                      case "wof":
                        return t("wheel-of-fortune")
                      case "free-spin":
                        return t("free-spin")
                    }
                  };

                  return (
                    <InnerContent
                      reward={reward}
                      ClaimHandler={() => ClaimHandler()}
                      topImgUrl={topImgUrl()!}
                      title={title()!}
                    />
                  );
                })}
              </>
            )}
          </>
        )}
      </>
    </div>
  );

  //   </div>
  // );
}

function InnerContent({
  ClaimHandler,
  topImgUrl,
  title,
  reward,
}: {
  ClaimHandler: () => void;
  topImgUrl: string;
  title: string;
  reward: Record<string, any>;
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  console.log(reward, title);

  return (
    <Tooltip
      placement="bottom"
      isOpen={isTooltipOpen}
      classNames={{
        content: clsx(
          "bg-gradient-to-b from-[#014235] to-[#02292B] text-tiny p-3 text-left sm:text-sm flex items-start gap-1 min-w-[140px] sm:min-w-[180px] relative mt-2"
        ),
      }}
      content={<span className="w-full text-center">Coming Soon!</span>}
    >
      <motion.div
        whileHover={{
          scale: 1.05,
        }}
        role="button"
        onClick={() => {
          // if (reward.type === "lp-store") {
          //   setIsTooltipOpen((prev) => !prev);
          //   return;
          // }
          if (reward.type === "birthday" || reward.type === "lp-store") {
            ClaimHandler();
            return;
          }

          reward.data && ClaimHandler();
        }}
        // onPointerEnter={() => reward.type === "lp-store" && setIsTooltipOpen(true)}
        // onPointerLeave={() => reward.type === "lp-store" && setIsTooltipOpen(false)}
        className={clsx(
          "w-28 pt-12 md:w-32",
          {
            // "cursor-not-allowed": !reward.data && reward.type !== "birthday",
            // "cursor-pointer": reward.type == "birthday" ? true : reward.data && reward.type !== "birthday",
          },
          reward.data ? "cursor-pointer" : "cursor-not-allowed",
          {
            "cursor-pointer": reward.type == "birthday",
          },
          {
            "cursor-pointer": reward.type == "lp-store",
          }
        )}
      >
        <div className="relative">
          <div className="absolute top-0 flex w-full justify-center">
            <Image
              className={clsx("z-50 w-1/2 -translate-y-1/2", {
                grayscale: !reward.data && reward.type !== "lp-store" && reward.type !== "birthday",
              })}
              src={topImgUrl}
              alt="Register Gif"
              width={200}
              height={200}
            />
          </div>
          <div className="absolute inset-0 z-50 flex flex-col items-center justify-center px-2 pb-4">
            <div className="text-center text-xl font-bold leading-5">{title}</div>
            {/* {reward.type === "otb" && reward.data && (
        <div className="text-xl font-bold">{reward.data.title}</div>
        )} */}
            {/* <div className="text-xl font-bold">{otb.data.title}</div> */}
          </div>
          <Image
            className={clsx("filter", {
              grayscale: !reward.data && reward.type !== "lp-store" && reward.type !== "birthday",
            })}
            src="/rewards-experimental.png"
            alt="Register Gif"
            width={286}
            height={317}
          />
        </div>
      </motion.div>
    </Tooltip>
  );
}
